import app from './index';

export default class HomeController {

	constructor () {

    this.anfragen = app.api.anfragen.query( (success) => {
      success.forEach(a => {
        a.menge = a.Artikel.sum(aa => aa.Menge);
      });
    });
		this.refresh();
	}

	refresh() {
	}
}



/** WEBPACK FOOTER **
 ** ./public/app/HomeController.js
 **/